import { useFormContext } from 'react-hook-form'
import SelectTagInput from '@/components/SelectTagInput'
import { PostFormData } from '../types'

interface FormTagsSectionProps {
  trends: { id: string; name: string }[]
  trendsLoading: boolean
  territories: { id: string; name: string }[]
  territoriesLoading: boolean
  contexts: { id: string; name: string }[]
  contextsLoading: boolean
  topics: { id: string; name: string }[]
  topicsLoading: boolean
}

export function FormTagsSection({
  trends,
  trendsLoading,
  territories,
  territoriesLoading,
  contexts,
  contextsLoading,
  topics,
  topicsLoading,
}: FormTagsSectionProps) {
  const { watch, setValue } = useFormContext<PostFormData>()
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="text-sm font-medium">Tendências (Opcional)</label>
        <SelectTagInput
          value={watch('trends') || []}
          onChange={(value) => setValue('trends', value)}
          placeholder="Selecione tendências"
          items={trends}
          loading={trendsLoading}
          hideButton
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium">Territórios (Opcional)</label>
        <SelectTagInput
          value={watch('territories') || []}
          onChange={(value) => setValue('territories', value)}
          placeholder="Selecione territórios"
          items={territories}
          loading={territoriesLoading}
          hideButton
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium">Contextos (Opcional)</label>
        <SelectTagInput
          value={watch('contexts') || []}
          onChange={(value) => setValue('contexts', value)}
          placeholder="Selecione contextos"
          items={contexts}
          loading={contextsLoading}
          hideButton
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-medium">Tópicos (Opcional)</label>
        <SelectTagInput
          value={watch('topics') || []}
          onChange={(value) => setValue('topics', value)}
          placeholder="Selecione tópicos"
          items={topics}
          loading={topicsLoading}
          hideButton
        />
      </div>
    </div>
  )
}
